import en from './en';

const es = {
  ...en,
  lang: 'es',
  langName: 'Español',
  flag: '🇪🇸',
  siteTitle: 'Simulacros TOEFL iBT gratis - Análisis con IA | Power TOEFL 2026',
  siteDescription: 'Practica gratis los últimos simulacros TOEFL 2026 con análisis de IA para Reading, Listening, Speaking y Writing.',
  ogTitle: 'Simulacros TOEFL iBT gratis - Análisis con IA | Power TOEFL 2026',

  navGrammar: 'Gramática',
  navPractice: 'Práctica por sección',
  navScoreChart: 'Tabla de puntaje',
  navVocabulary: 'Vocabulario',
  navTips: 'Consejos y estrategia',
  navFAQ: 'Preguntas frecuentes',
  navReading: 'Reading',
  navListening: 'Listening',
  navSpeaking: 'Speaking',
  navWriting: 'Writing',
  navQuestionPool: 'Banco de preguntas',
  navResources: 'Recursos',
  navPremium: 'Plan Premium',

  loginButton: 'Iniciar sesión',
  wrongAnswers: 'Cuaderno de errores',
  logout: 'Cerrar sesión',
  loginRequired: 'Debes iniciar sesión para usar errores guardados y continuar.',

  heroBadge: 'Sistema Premium de TOEFL',
  moreTools: 'Más herramientas de estudio',
  practiceLabel: 'Práctica por sección',
  practiceDesc: 'Entrena Reading y Listening por separado',
  scoreChartLabel: 'Conversión de puntaje',
  scoreChartDesc: 'De aciertos a puntaje estimado',
  vocabLabel: 'Vocabulario',
  vocabDesc: 'Vocabulario esencial del TOEFL',
  tipsLabel: 'Consejos y estrategia',
  tipsDesc: 'Guía de Reading y Listening',
  catLabel: 'Prueba adaptativa CAT',
  catDesc: 'La dificultad se ajusta automáticamente',
  guideLabel: 'Guías de estudio',
  guideDesc: 'Estrategias por habilidad y por puntaje',
  grammarSectionTitle: 'Libro de gramática inglesa',
  grammarSectionDesc: 'Construye tu base gramatical paso a paso',
  grammarViewAll: 'Ver todo',

  footerMockTest: 'Práctica',
  footerQuestionPool: 'Banco de preguntas',
  footerPractice: 'Práctica por sección',
  footerStudy: 'Estudio',
  footerBooks: 'Libros recomendados',
  footerEtc: 'Más',
  footerLC: 'Práctica de Listening',
  footerRC: 'Práctica de Reading',
  footerSpeaking: 'Práctica de Speaking',
  footerWriting: 'Práctica de Writing',
  footerLCStrategy: 'Estrategia de Listening',
  footerRCStrategy: 'Estrategia de Reading',
  footerGuide: 'Guía de estudio',
  footerPrivacy: 'Política de privacidad',
  footerTerms: 'Términos de servicio',
  footerRefund: 'Política de reembolso',
  footerAbout: 'Acerca de',
  footerCopyright: '© 2026 Power TOEFL. Todos los derechos reservados.',
  footerDisclaimer: 'TOEFL® es una marca registrada de ETS. Power TOEFL es una plataforma independiente y no está afiliada a ETS.',

  heroTitle1: 'Una sola plataforma',
  heroTitle2: 'para subir tu puntuación TOEFL',
  heroDesc1: 'Desde simulacros realistas hasta análisis de errores,',
  heroDesc2: 'todo en un solo lugar para tu meta.',
  fullTestCardLabel: 'Simulacro completo',
  fullTestCardDesc: 'Práctica real de Reading y Listening',
  proBadgeLabel: 'Pro',
  googleLogin: 'Empezar con Google',

  pwaAddToHome: 'Añadir a pantalla de inicio',
  pwaAddToHomeDesc: 'Abre Power TOEFL más rápido como si fuera una app.',
  pwaInstall: 'Instalar',
  pwaIOSGuide: 'Compartir',

  resumeTest: 'Continuar',
  resumeDesc: '{0} ronda {1} — {2}/{3} preguntas',
  progressLabel: 'Progreso',
  timerLabel: 'Tiempo restante',
  timeUp: '¡Tiempo terminado!',
  navHome: 'Inicio',
  navSettings: 'Consejos',

  speakingPageH1: 'Práctica de TOEFL Speaking',
  speakingPageDesc: 'Practica todas las tareas de Speaking con grabación y feedback de IA.',
  writingPageH1: 'Práctica de TOEFL Writing',
  writingPageDesc: 'Entrena Build a Sentence, Email y Academic Discussion.',
  grammarBookTitle: 'Gramática TOEFL',
  grammarCourseName: 'Gramática inglesa para TOEFL',
  grammarBreadcrumb: 'Gramática',

  statsTitle: 'Estadísticas de estudio | Power TOEFL',
  statsDesc: 'Revisa tu progreso, debilidades y actividad semanal.',
  statsH1: 'Mis estadísticas',
  statsLoginPrompt: 'Inicia sesión para ver tus estadísticas personales.',
  statsLast7Days: 'Últimos 7 días',
  statsTotalWrong: 'Errores totales',

  leaderboardTitle: 'Ranking de estudio',
  leaderboardWeekly: 'Semanal',
  leaderboardMonthly: 'Mensual',
  leaderboardLoading: 'Cargando...',
  leaderboardEmpty: 'Todavía no hay datos para este {period}.',
  leaderboardEmptyWeek: 'periodo',
  leaderboardEmptyMonth: 'mes',
  leaderboardHint: 'Resuelve tests y entra automáticamente en el ranking.',
  leaderboardRank: 'Puesto',
  leaderboardNickname: 'Nombre',
  leaderboardSolved: 'Resueltas',
  leaderboardAccuracy: 'Precisión',
  leaderboardMe: 'Yo',

  pricingTitle: 'Planes Power TOEFL Pro — €12,99/mes | Free vs Premium | 2026',
  pricingDesc: 'Compara el plan gratis con Pro: práctica ilimitada, análisis con IA, explicaciones detalladas y una preparación TOEFL más eficiente.',
  pricingLoginRequired: 'Inicia sesión para continuar.',
  pricingPaymentError: 'Se produjo un error durante el pago.',
  pricingPaymentCancelled: 'El pago fue cancelado.',
  pricingFaqQ1: '¿Cuál es la diferencia entre Free y Pro?',
  pricingFaqA1: 'Pro incluye preguntas ilimitadas, explicaciones detalladas y análisis con IA.',
  pricingFaqQ2: '¿Puedo pedir un reembolso?',
  pricingFaqA2: 'Debido a la naturaleza de los productos digitales, en principio no hay reembolso. Sin embargo, puede haber reembolso excepcional cuando lo exija la ley, haya cobro duplicado, no se haya prestado el servicio o exista una falla técnica grave.',
  pricingFaqQ3: '¿Cómo cancelo mi suscripción?',
  pricingFaqA3: 'Puedes gestionar o cancelar tu suscripción en la plataforma de pago.',
  pricingFaqQ4: '¿Qué diferencia hay entre el plan anual y Lifetime?',
  pricingFaqA4: 'El anual se renueva cada año; Lifetime es un pago único cuando está disponible.',

  aboutCtaHeading: 'Empieza ahora',
  aboutCtaDesc: 'Comienza con un simulacro TOEFL gratuito.',
  aboutCtaStart: 'Probar gratis',
  aboutCtaPricing: 'Ver Premium',

  // --- Auto-translated UI strings ---
  lcTitle: "Comprensión auditiva",
  lcSubtitle: "Comprensión auditiva - 28 preguntas",
  lcTime: "36 min",
  rcTitle: "Lectura",
  rcSubtitle: "Lectura - 20 preguntas",
  rcTime: "35 min",
  startTest: "Iniciar prueba",
  fullTestStart: "Iniciar simulacro de examen completo (Lectura -> Comprensión auditiva)",
  fullTestDesc: "Completa ambas secciones en secuencia",
  part1: "Lectura académica (20)",
  part2: "Conversaciones (10)",
  part3: "Conferencias (18)",
  statQuestions: "Preguntas",
  statParts: "Partes",
  statMinutes: "Minutos",
  faqTitle: "Preguntas frecuentes",
  faqDesc: "Encuentra respuestas sobre TOEFL y Power TOEFL.",
  faqPageTitle: "Registro, Puntuación, Validez del TOEFL - Preguntas frecuentes 2026 | Power TOEFL",
  faqPageDesc: "Registro, conversión de puntuaciones, validez y estrategia por sección en una sola página.",
  faqMore: "¿Necesitas más ayuda? Seguimos actualizando estas preguntas frecuentes.",
  scoreChartPageTitle: "Conversión de Puntuación TOEFL 2026 - Consulta las Puntuaciones por Sección al Instante | Power TOEFL",
  scoreChartPageDesc: "Conversión de puntuaciones por sección TOEFL para Lectura, Comprensión auditiva, Expresión oral, Expresión escrita. Introduce las respuestas correctas para obtener una puntuación estimada y orientación sobre objetivos.",
  scoreChartHeading: "Tabla de Conversión de Puntuación TOEFL",
  scoreChartIntro: "Las tablas de 0–30 por sección y total 0–120 son estimaciones de estudio de Power TOEFL en la escala antigua/comparable. Los informes oficiales de 2026 priorizan puntuaciones por sección y total de 1–6 en incrementos de 0,5.",
  scoreChartLC: "Conversión de Lectura",
  scoreChartRC: "Conversión de Comprensión auditiva",
  scoreChartCorrect: "Correcto",
  scoreChartConverted: "Puntuación Convertida",
  scoreChartUnit: "",
  scoreChartPointUnit: "pts",
  scoreGuideTitle: "Guía de Puntuación Objetivo",
  scoreGuide900: "Nivel Superior",
  scoreGuide900Desc: "Meta: 28+ por sección. Fuerte para las mejores admisiones.",
  scoreGuide800: "Nivel Alto",
  scoreGuide800Desc: "Meta: 22+ por sección. Cumple la mayoría de los requisitos de admisión.",
  scoreGuide700: "Intermedio-Alto",
  scoreGuide700Desc: "Base académica alcanzada. Admisión condicional posible.",
  scoreGuide600: "Intermedio",
  scoreGuide600Desc: "Concéntrese primero en los fundamentos de Lectura y Comprensión Auditiva.",
  scoreChartFaqTitle: "Preguntas Frecuentes sobre la Puntuación del TOEFL",
  scoreChartCtaTitle: "Compruebe su nivel ahora",
  scoreChartCtaDesc: "Realice una prueba simulada gratuita del TOEFL y estime su puntuación.",
  scoreReadingHeader: "Lectura (0-30 pts)",
  scoreListeningHeader: "Comprensión Auditiva (0-30 pts)",
  scoreSpeakingHeader: "Expresión Oral (0-30 pts)",
  scoreWritingHeader: "Expresión Escrita (0-30 pts)",
  scoreSpeakingDesc: "4 tareas se puntúan en una escala de 0-4, luego se convierten a 30 puntos",
  scoreWritingDesc: "2 tareas se puntúan en una escala de 0-5, luego se convierten a 30 puntos",
  vocabPageTitle: "600 Palabras TOEFL de Alta Frecuencia - Significados y Ejemplos | Power TOEFL",
  vocabPageDesc: "Aprenda 600 palabras TOEFL por categoría con significados y ejemplos instantáneos.",
  vocabHeading: "Vocabulario TOEFL Esencial",
  vocabIntro: "Estudie vocabulario imprescindible por categoría. Haga clic para revelar los significados.",
  vocabShowAll: "Mostrar todo",
  vocabHideAll: "Ocultar todo",
  vocabReset: "Reiniciar",
  vocabClickToReveal: "Haga clic para revelar el significado",
  vocabMotivation: "La repetición constante eleva su puntuación en el TOEFL.",
  vocabMyWords: "Mi Vocabulario",
  vocabAddWord: "Añadir Palabra",
  vocabAddWordPlaceholder: "Introduzca una palabra en inglés",
  vocabMyWordsEmpty: "Aún no se han añadido palabras. Añade tu primera palabra arriba.",
  vocabDeleteWord: "Eliminar",
  vocabLookingUp: "Buscando...",
  vocabQuizTitle: "Cuestionario de vocabulario",
  vocabQuizDesc: "Evalúa sinónimos y antónimos de palabras aprendidas.",
  vocabQuizMode_synonym: "Cuestionario de sinónimos",
  vocabQuizMode_antonym: "Cuestionario de antónimos",
  vocabQuizMode_mixed: "Cuestionario mixto",
  vocabQuizClose: "Cerrar",
  vocabQuizNoQuestions: "Todavía no hay suficientes preguntas en esta categoría.",
  vocabQuizBack: "Atrás",
  vocabQuizResult: "Resultado del cuestionario",
  vocabQuizExcellent: "¡Excelente!",
  vocabQuizGood: "Gran trabajo. Un poco más de práctica y estarás listo.",
  vocabQuizKeepGoing: "¡Sigue así!",
  vocabQuizRetry: "Reintentar",
  vocabQuizFindSynonym: "Elige el sinónimo de la siguiente palabra",
  vocabQuizFindAntonym: "Elige el antónimo de la siguiente palabra",
  vocabQuizNext: "Siguiente",
  vocabQuizFinish: "Ver resultado",
  vocabQuizStart: "Iniciar cuestionario",
  vocabCatNaturalScience: "Ciencias Naturales",
  vocabCatSocialScience: "Ciencias Sociales",
  vocabCatHumanities: "Humanidades",
  vocabCatLifeScience: "Ciencias de la Vida",
  vocabCatTechnology: "Tecnología/Ingeniería",
  vocabCatAcademicGeneral: "Académico General",
  tipsLCPageTitle: "Cómo aumentar la puntuación de comprensión auditiva del TOEFL | Rutina de entrenamiento LC - Power TOEFL",
  tipsLCPageDesc: "Entrenamiento práctico de comprensión auditiva del TOEFL para obtener puntuaciones LC más altas: toma de notas para conversaciones y conferencias, inferencia y preguntas sobre la actitud del orador.",
  tipsLCHeading: "Estrategia para la puntuación de comprensión auditiva del TOEFL",
  tipsLCIntro: "Estrategias centrales y rutinas prácticas para cada parte del Listening del TOEFL.",
  tipsLCPractice: "Practicar Listening Ahora",
  tipsLCPracticeDesc: "Aplica la estrategia con una prueba de práctica real.",
  tipsLCStartTest: "Empezar prueba de Listening",
  tipsRCPageTitle: "Estrategia de Reading del TOEFL - Guía de Pasajes Académicos | Power TOEFL",
  tipsRCPageDesc: "Estrategia de Reading del TOEFL para pasajes académicos: asignación de tiempo, inferencia y enfoque de preguntas de resumen.",
  tipsRCHeading: "Estrategia de Reading del TOEFL",
  tipsRCIntro: "Una guía práctica para la estrategia y el tiempo de los pasajes de Reading del TOEFL.",
  tipsRCPractice: "Practicar Reading Ahora",
  tipsRCPracticeDesc: "Aplica la estrategia con una prueba de práctica real.",
  tipsRCStartTest: "Empezar prueba de Reading",
  tips7DayTitle: "Plan de estudio de última hora de 7 días",
  tips7DayDesc: "Maximiza la puntuación con una rutina enfocada de última semana",
  tipsTrapTitle: "Guía de patrones de trampas",
  tipsTrapDesc: "Aprende los 5 patrones de trampas más comunes con anticipación",
  aboutPageTitle: "Acerca de Power TOEFL - Pruebas simuladas de TOEFL gratuitas y herramientas de estudio con IA",
  aboutPageDesc: "Practica el TOEFL con pruebas simuladas completas, análisis de debilidades con IA y revisión automática de respuestas incorrectas. Descubre lo que ofrece Power TOEFL.",
  aboutHeading: "Power TOEFL - Plataforma práctica de preparación para el TOEFL",
  aboutS1Title: "¿Qué es Power TOEFL?",
  aboutS1Body: "Power TOEFL es una plataforma gratuita en línea para estudiantes que se preparan para el TOEFL. Ofrecemos exámenes simulados completos, práctica generada por IA y herramientas de revisión de respuestas incorrectas.",
  aboutS2Title: "¿Para quién está destinada?",
  aboutS2Body: "Recomendado para estudiantes que preparan el TOEFL para admisiones, profesionales que buscan puntajes requeridos y estudiantes autodidactas que desean una práctica estructurada.",
  aboutS3Title: "Características clave",
  aboutFeature1: "Exámenes simulados completos al estilo TOEFL con múltiples rondas",
  aboutFeature2: "Práctica enfocada por sección para Reading, Listening, Speaking y Writing",
  aboutFeature3: "Generación de preguntas y análisis de debilidades con IA",
  aboutFeature4: "Cuaderno automático de respuestas incorrectas con revisión espaciada",
  aboutFeature5: "Tabla de conversión de puntuaciones y vocabulario esencial del TOEFL",
  aboutS4Title: "Gratis vs Premium",
  aboutS4Body: "La versión gratuita incluye exámenes simulados, práctica por sección y conversión de puntuaciones. La versión Premium añade generación ilimitada con IA, estudio sin anuncios y acceso completo a los simulacros.",
  aboutS5Title: "¿Por qué mejoran las puntuaciones?",
  aboutS5Body: "Con la repetición espaciada, el análisis de debilidades específicas y condiciones de práctica realistas, los estudiantes pueden construir un rendimiento de examen estable con el tiempo.",
  aboutS6Title: "Relación con ETS",
  aboutS6Body: "Power TOEFL es una plataforma de aprendizaje independiente y no está afiliada ni respaldada por ETS. TOEFL es una marca registrada de ETS.",
  aboutS7Title: "Contacto",
  aboutS7Body: "Para consultas de servicio, póngase en contacto con skdaks0731@gmail.com.",
  catPageTitle: "Examen Adaptativo TOEFL (CAT) - Dificultad Automática por IA | Power TOEFL",
  catPageDesc: "Examen de práctica adaptativo por computadora del TOEFL. La IA ajusta automáticamente la dificultad de las preguntas según su rendimiento.",
  catHeading: "Examen Adaptativo (CAT)",
  catIntro: "La dificultad se ajusta automáticamente a su precisión. {count} preguntas por sesión.",
  catNote: "ℹ️ Nota: El TOEFL iBT real es un examen lineal (no adaptativo). Este Practice CAT es una herramienta de estudio que ajusta la dificultad a tu rendimiento para que encuentres tu nivel rápidamente; no es una simulación del formato real del examen.",
  catSelectSection: "Seleccionar Sección",
  catStartBtn: "Iniciar Examen Adaptativo",
  catLoading: "Cargando siguiente pregunta...",
  catNoMore: "No hay más preguntas disponibles",
  catComplete: "Examen Adaptativo Completado",
  catAccuracy: "Precisión",
  catFinalLevel: "Dificultad final",
  catTryAgain: "Intentar de Nuevo",
  catViewResults: "Ver Resultados",
  catNext: "Siguiente",
  catExplanation: "Explicación",
  catStop: "Detener",
  catPlayAudio: "Reproducir Audio",
  catReadingPassage: "Texto de Lectura",
  pricingSaveBadge: "30% de descuento",
  pricingPerMonth: "mes",
  pricingSSL: "Pago seguro",
  pricingCard: "Pago con tarjeta",
  pricingPaymentSuccess: "¡Premium activado con éxito!",
  pricingCurrentPlan: "Plan actual",
  grammarSystematic: "Aprendizaje sistemático de la gramática",
  grammarBookDesc: "Aprende 20 temas esenciales de gramática TOEFL con ejemplos prácticos y ejercicios.",
  grammarTestAfter: "¡Pruébalo justo después de estudiar!",
  grammarTestAfterDesc: "Verifica cómo aparecen los puntos gramaticales en preguntas reales del TOEFL.",
  grammarMockTest: "Examen de práctica",
  grammarDoneTitle: "¿Terminaste de estudiar gramática?",
  grammarDoneDesc: "Aplica lo que aprendiste en un examen simulado. Las respuestas incorrectas se guardan automáticamente para su revisión.",
  grammarStartRC: "Iniciar examen de práctica de Lectura",
  grammarPracticePart5: "Práctica de Gramática de Lectura",
  leaderboardMyRank: "🏅 Mi rango: #{rank}",
  speakingPageSub: "{count}+ preguntas gratuitas de Speaking — Listen and Repeat · Interview",
  speakingPageTitle: "Práctica de TOEFL Speaking 2026 - {count}+ Preguntas y Respuestas de Ejemplo Gratis | Power TOEFL",
  speakingAllTasks: "Todas",
  speakingNoPrompts: "Aún no hay preguntas de Speaking",
  speakingNoPromptsSub: "Se están generando preguntas. Por favor, vuelve pronto.",
  speakingResponseTime: "Tiempo de respuesta",
  writingPageSub: "{count}+ tareas gratuitas de Writing — Build a Sentence · Email · Academic Discussion",
  writingPageTitle: "Práctica de TOEFL Writing 2026 - {count}+ Tareas Gratis | Power TOEFL",
  writingAllTasks: "Todas",
  writingNoPrompts: "Aún no hay preguntas de Writing",
  writingNoPromptsSub: "Se están generando preguntas. Por favor, vuelve pronto.",
  testPrevious: "Anterior",
  testNext: "Siguiente",
  testQuestion: "Pregunta",
  testQuestionPrompt: "Lee la pregunta y elige la mejor respuesta.",
  testMarkAnswer: "Por favor, marca el número de la mejor respuesta.",
  testSelect: "Seleccionar",
  testShowAnswer: "Mostrar respuesta y explicación",
  testCorrect: "¡Correcto!",
  testIncorrect: "Incorrecto.",
  testSubmit: "Enviar Prueba",
  testContinue: "Continuar",
  resultsTitle: "Resultados de la Prueba {0}",
  resultsTimeUsed: "Tiempo utilizado: {0}m {1}s",
  resultsEstimatedScore: "Puntuación estimada (sobre 30)",
  resultsCorrect: "Correctas",
  resultsIncorrect: "Incorrectas",
  vocabSynonyms: "Sinónimos",
  vocabAntonyms: "Antónimos",
  tipsLCButton: "Estrategia de Listening",
  tipsRCButton: "Estrategia de Reading",
  practiceRelatedLinks: "📌 Contenido de estudio relacionado",
  practiceOtherParts: "Otras partes",
  practiceMockTestCTA: "Practica con una prueba completa",
  practiceTipsLink: "Ver estrategias específicas de la parte",
  practiceGrammarLink: "Estudiar gramática",
  practiceNotFound: "Parte no encontrada.",
  practiceQuestionType: "Tipo de pregunta",
  practiceTips: "💡 Consejos de estrategia",
  practiceExamples: "📝 Preguntas de ejemplo",
  practiceIntro: "📋 Resumen de la parte",
  practiceCommonTypes: "📊 Tipos de preguntas comunes",
  practiceStrategy: "🎯 Estrategias clave",
  practiceRecommendedFor: "👤 Recomendado para",
  practiceFAQ: "❓ Preguntas frecuentes",
  practiceCTA: "Practicar ahora",
  practiceCTADesc: "Puedes practicar la Parte {0} en un entorno de prueba realista.",
  practiceStartTest: "Iniciar prueba simulada {0}",
  practiceQuestions: "Preguntas",
  practicePartSelect: "Seleccionar parte",
  roundsTitle: "Rondas de exámenes de práctica",
  roundLabel: "Examen de práctica TOEFL",
  roundUnit: "ronda",
  comingSoon: "Próximamente",
  testLoginPrompt: "Las notas de respuestas incorrectas y las funciones de reanudación requieren inicio de sesión.",
  testGoogleLogin: "Empezar con Google en 3 segundos",
  roundSelect: "Seleccionar otra ronda",
  testAnswered: "Respondido",
  testSubmitTitle: "¿Enviar {0} examen?",
  testSubmitDesc: "Respondiste {1} de {0} preguntas.",
  testUnanswered: "{0} preguntas sin responder.",
  testCannotUndo: "Esta acción no se puede deshacer.",
  testSubmitBtn: "Enviar",
  resultsAccuracy: "Precisión",
  resultsReview: "Revisar respuestas",
  resultsYourAnswer: "Tu respuesta: {0}",
  resultsCorrectAnswer: "Respuesta correcta: {0}",
  resultsNoAnswer: "Sin respuesta",
  resultsHome: "Inicio",
  resultsWrongNotes: "Respuestas incorrectas",
  resultsRetry: "Reintentar",
  resultsShare: "Compartir resultados",
  resultsShareText: "¡Mi puntaje estimado del TOEFL {0} es {1}! ({2}/{3} correctas, {4}% de precisión) ¡Pon a prueba tus habilidades gratis con Power TOEFL!",
  resultsShareCopied: "¡Resultados copiados al portapapeles!",
  resultsNoResults: "Sin resultados de examen.",
  resultsGoHome: "Ir a inicio",
  resultsSaved: "{0} respuestas incorrectas guardadas en tus respuestas incorrectas",
  wrongAnswersTitle: "Respuestas incorrectas",
  wrongAnswersSaved: "Elementos guardados",
  wrongAnswersHome: "Inicio",
  wrongAnswersPracticeAll: "Practicar todo",
  wrongAnswersAll: "Todo",
  wrongAnswersNoItems: "Aún no hay respuestas incorrectas. ¡Haz una prueba primero!",
  wrongAnswersYourAnswer: "Tu respuesta: {0}",
  wrongAnswersCorrectIs: "Respuesta correcta: {0}",
  wrongAnswersReviewed: "Revisado",
  wrongAnswersRemoved: "Eliminado de respuestas incorrectas",
  wrongAnswersPracticeMode: "Modo de práctica",
  wrongAnswersCorrectMsg: "¡Correcto!",
  wrongAnswersIncorrectMsg: "Incorrecto. Respuesta correcta: {0}",
  wrongAnswersNextQuestion: "Siguiente pregunta",
  wrongAnswersFinish: "Terminar práctica",
  wrongAnswersExitPractice: "Salir de la práctica",
  wrongAnswersPracticeComplete: "¡Práctica completada!",
  wrongAnswersNoPractice: "No hay respuestas incorrectas para practicar",
  wrongAnswersLimitNotice: "Solo se muestran las 500 respuestas incorrectas más recientes.",
  privacyPageTitle: "Política de privacidad — Power TOEFL",
  privacyPageDesc: "Política de privacidad de Power TOEFL.",
  privacyHeading: "Política de privacidad",
  privacyLastUpdated: "Última actualización: 29 de marzo de 2026",
  privacyS1Title: "1. Información personal recopilada",
  privacyS1Body: "Power TOEFL recopila tu dirección de correo electrónico, nombre y foto de perfil cuando inicias sesión con Google para proporcionar el servicio. Cuando realizas pagos, la información de pago se procesa a través de proveedores de pago (Dodo Payments/PayPal); no almacenamos directamente los detalles de la tarjeta de pago.",
  privacyS2Title: "2. Propósito de uso",
  privacyS2Body: "Los datos personales recopilados se utilizan únicamente para guardar respuestas incorrectas, rastrear el progreso del estudio, gestionar suscripciones, atención al cliente y mejorar el servicio.",
  privacyS3Title: "3. Retención y eliminación de datos",
  privacyS3Body: "Cuando un usuario elimina su cuenta, los datos personales se eliminan inmediatamente. Los registros de pago se conservan hasta 5 años según lo exige la ley fiscal y luego se eliminan. Si otras leyes exigen la retención, los datos se conservarán durante el período requerido y luego se eliminarán.",
  privacyS4Title: "4. Divulgación a terceros",
  privacyS4Body: "Para procesar pagos, compartimos la información mínima requerida (correo electrónico) con Dodo Payments (Comerciante de Registro) o PayPal. No proporcionamos datos personales de los usuarios a otros terceros, excepto cuando lo exige la ley.",
  privacyS5Title: "5. Cookies y anuncios",
  privacyS5Body: "Este sitio publica anuncios a través de Google AdSense y utiliza cookies para tal fin. Las cookies se pueden gestionar en la configuración de su navegador. Para obtener detalles sobre las cookies publicitarias de Google, consulte la Política de privacidad de Google.",
  privacyS6Title: "6. Transferencias internacionales de datos",
  privacyS6Body: "Este servicio utiliza servidores ubicados en el extranjero y los datos pueden transferirse internacionalmente para el procesamiento de pagos. Protegemos los datos personales con las medidas de seguridad adecuadas.",
  privacyS7Title: "7. Derechos del usuario",
  privacyS7Body: "Los usuarios pueden solicitar acceso, corrección o eliminación de sus datos personales en cualquier momento. Los residentes de la UE/EEE tienen derechos adicionales bajo el RGPD. Para eliminar su cuenta, cierre sesión y contáctenos.",
  privacyS8Title: "8. Contacto",
  privacyS8Body: "Para consultas de privacidad, comuníquese con skdaks0731@gmail.com.",
  termsPageTitle: "Términos de servicio — Power TOEFL",
  termsPageDesc: "Términos de servicio de Power TOEFL.",
  termsHeading: "Términos de servicio",
  termsLastUpdated: "Última actualización: 29 de marzo de 2026",
  termsS1Title: "1. Resumen del servicio",
  termsS1Body: "Power TOEFL es una plataforma de aprendizaje en línea para la preparación del TOEFL, operada por ddookddak (nuestro nombre legal comercial registrado). Ofrecemos funciones gratuitas y suscripciones premium pagas (Pro/De por vida) que incluyen simulacros de examen, práctica por sección, generación de preguntas con IA y notas de respuestas incorrectas.",
  termsS2Title: "2. Elegibilidad",
  termsS2Body: "El servicio está disponible para usuarios mayores de 14 años. Algunas funciones (notas de respuestas incorrectas, práctica con IA, etc.) requieren iniciar sesión con una cuenta de Google, y las funciones premium requieren una suscripción de pago.",
  termsS3Title: "3. Propiedad intelectual",
  termsS3Body: "El contenido de este sitio (preguntas, diseño, código, etc.) es propiedad de Power TOEFL. TOEFL es una marca registrada de ETS; este sitio no está afiliado a ETS.",
  termsS4Title: "4. Servicios de pago y pagos",
  termsS4Body: "Las suscripciones premium se procesan a través de servicios de pago de terceros (Dodo Payments/PayPal). Las tarifas de suscripción se cargan automáticamente o como un pago único, según el plan seleccionado (mensual/anual/de por vida). Los precios pueden incluir IVA; el monto final se muestra al finalizar la compra. Consulte la política de reembolso separada para obtener detalles sobre los reembolsos.",
  termsS5Title: "5. Descargo de responsabilidad",
  termsS5Body: "Las puntuaciones de los simulacros de examen y los materiales de estudio proporcionados por este servicio son solo de referencia y no garantizan los resultados reales del TOEFL. No somos responsables de los daños directos o indirectos resultantes del uso del servicio.",
  termsS6Title: "6. Conducta prohibida",
  termsS6Body: "No puede copiar ni distribuir preguntas sin permiso, sobrecargar el sistema, compartir cuentas con otros ni participar en otras actividades ilegales.",
  termsS7Title: "7. Cambios y suspensión del servicio",
  termsS7Body: "El operador puede cambiar o suspender el servicio sin previo aviso y no está obligado a proporcionar compensación.",
  termsS8Title: "8. Cancelación de la suscripción",
  termsS8Body: "Las suscripciones pagas se pueden cancelar en cualquier momento. Después de la cancelación, las funciones premium seguirán estando disponibles hasta el final del período pagado, después de lo cual la cuenta volverá al plan gratuito.",
  termsS9Title: "9. Cambios en los términos",
  termsS9Body: "Estos términos pueden actualizarse según sea necesario; los cambios se publicarán en el sitio. El uso continuado del servicio después de los cambios constituye la aceptación de los términos actualizados.",
  refundPageTitle: "Política de reembolso — Power TOEFL",
  refundPageDesc: "Política de reembolso de suscripciones premium de Power TOEFL.",
  refundHeading: "Política de Reembolso",
  refundLastUpdated: "Última actualización: 15 de abril de 2026",
  refundS1Title: "1. Principio de reembolso",
  refundS1Body: "Debido a la naturaleza de los productos digitales, en principio no hay reembolso.",
  refundS2Title: "2. Casos excepcionales de reembolso",
  refundS2Body: "Sin embargo, puede haber reembolso excepcional cuando lo exija la ley, haya cobro duplicado, no se haya prestado el servicio o exista una falla técnica grave.",
  refundS3Title: "3. Cómo contactarnos",
  refundS3Body: "Para consultas sobre reembolsos, use el canal de soporte/comentarios. Contacto: skdaks0731@gmail.com",
  refundS4Title: "4. Cancelación de suscripción",
  refundS4Body: "Las suscripciones de pago se pueden cancelar en cualquier momento. Tras cancelar, el acceso premium se mantiene hasta el final del periodo de facturación actual y no habrá cargos adicionales.",
  refundS5Title: "",
  refundS5Body: "",
  refundS6Title: "",
  refundS6Body: "",
  grammarChapter: "Capítulo",
  aiPracticeTitle: "Genera preguntas ilimitadas de TOEFL con IA — elige parte y dificultad para preguntas instantáneas | Power TOEFL",
  aiPracticeDesc: "Selecciona una parte y dificultad y la IA generará instantáneamente preguntas de TOEFL. Preguntas de práctica gratuitas con explicaciones automáticas — obtén preguntas nuevas cada día.",
  aiPracticeH1: "✨ Generador de Preguntas de TOEFL con IA",
  aiPracticeSub: "La IA genera preguntas de TOEFL en tiempo real con la dificultad que elijas.",
  aiPartLabel: "Parte",
  aiDiffLabel: "Dificultad",
  aiBeginner: "Principiante (1.0–2.5)",
  aiIntermediate: "Intermedio (3.0–4.5)",
  aiAdvanced: "Avanzado (5.0–6.0)",
  aiGenerate: "Generar preguntas",
  aiGenerating: "Generando...",
  aiRemainingToday: "{0} restantes este mes",
  aiLimitReached: "Has usado todos los créditos de IA este mes",
  aiLimitUpgrade: "¡Compra más créditos o mejora tu plan!",
  aiUpgrade: "Mejorar",
  aiListenPrompt: "🔊 Para las preguntas de Comprensión Oral, escucha el audio mientras respondes",
  aiPlayAudio: "Reproducir audio",
  aiStopAudio: "Detener",
  aiCorrect: "✅ ¡Correcto!",
  aiWrong: "❌ Incorrecto.",
  aiCorrectAnswer: "Respuesta correcta: {0}",
  aiPrev: "Anterior",
  aiNext: "Siguiente",
  aiNewQuestions: "Nuevas preguntas",
  aiEmptyTitle: "Generar preguntas con IA",
  aiEmptyDesc: "Selecciona una parte y dificultad, luego presiona \"Generar preguntas\".",
  aiLoadingMain: "La IA está generando y validando preguntas...",
  aiLoadingSub: "Tarda aproximadamente 10-20 segundos",
  statsTotalQuizzes: "Cuestionarios totales",
  statsTotalQuestions: "Preguntas totales",
  statsAccuracy: "Precisión",
  statsWrongSummary: "Resumen de respuestas incorrectas",
  statsViewAll: "Ver respuestas incorrectas",
  statsReviewed: "Revisado",
  statsPending: "Pendiente de revisión",
  statsTopicAccuracy: "Precisión por tema gramatical",
  statsAttempts: "{0} intentos",
  statsEmpty: "Aún no hay registros de estudio. ¡Prueba un cuestionario de gramática!",
  statsStartGrammar: "Iniciar estudio de gramática",
  testLCTitle: "Simulacro de examen de lectura TOEFL gratuito — lectura de pasajes académicos | 2026",
  testLCDesc: "Simulacro de examen de lectura TOEFL gratuito y actualizado 2026. 20 preguntas basadas en pasajes académicos. Las respuestas incorrectas se guardan automáticamente.",
  testRCTitle: "Simulacro de examen de comprensión oral TOEFL gratuito — conversaciones y conferencias | 2026",
  testRCDesc: "Simulacro de examen de comprensión oral TOEFL gratuito y actualizado 2026. 28 preguntas de conversaciones y conferencias. Se proporcionan explicaciones de IA y notas sobre respuestas incorrectas.",
  reviewTitle: "Revisión de hoy",
  reviewDesc: "Sistema de revisión inteligente basado en la curva del olvido de Ebbinghaus",
  reviewSubtitle: "Repasa en los momentos óptimos según la curva del olvido",
  reviewRemaining: "Repasos restantes",
  reviewProgress: "Progreso del repaso",
  reviewCompleted: "🎉 Repaso de hoy completado!",
  reviewCompletedDesc: "{0} preguntas repasadas",
  reviewEmpty: "No hay elementos de repaso para hoy",
  reviewEmptyDesc: "O has completado todos los repasos o aún no hay respuestas incorrectas.",
  reviewStage: "Etapa {0}",
  reviewNextInterval: "Intervalo de {0} días",
  reviewCorrect: "¡Correcto! Pasa a la siguiente etapa.",
  reviewWrong: "Incorrecto. Reiniciando en la etapa 1.",
  reviewNextReview: "Próximo repaso: en {0} días",
  reviewResetMsg: "Incorrecto — harás un repaso de nuevo en 1 día.",
  reviewNext: "Siguiente pregunta",
  reviewFinish: "Finalizar",
  reviewHowItWorks: "Método de repaso de Ebbinghaus",
  reviewDaysLater: "{0} días después",
  reviewExplanation: "Los elementos incorrectos se repasan en intervalos de 1 → 3 → 7 → 14 → 30 → 60 días. Las respuestas correctas avanzan a la siguiente etapa; las incorrectas regresan a la etapa 1.",
  notifTitle: "Notificaciones",
  notifEmpty: "No hay notificaciones nuevas",
  notifMarkAllRead: "Marcar todo como leído",
  timeJustNow: "Justo ahora",
  timeMinutes: "Hace {0} minutos",
  timeHours: "Hace {0} horas",
  timeDays: "Hace {0} días",
  scoreCardEstimated: "Puntuación estimada",
  scoreCardCorrect: "Correcto",
  scoreCardIncorrect: "Incorrecto",
  scoreCardAccuracy: "Precisión",
  pushTitle: "Recibe notificaciones de estudio",
  pushDesc: "Te notificamos sobre tiempos de repaso, rachas y más.",
  pushEnable: "Activar notificaciones",
  navReview: "Repasar",
  navStats: "Estadísticas",
  navSubscription: "Suscripción",
  roundDetailHeading: "Examen de simulación completo de TOEFL",
  roundDetailOtherRounds: "Ver otras rondas",
  roundSuffix: "ronda",
  footer7DayPlan: "Plan de estudio de 7 días",
  footerTrapPatterns: "Patrones trampa",
  aiQuizTitle: "🤖 Preguntas de práctica personalizadas con IA",
  aiQuizDesc: "Preguntas de gramática TOEFL generadas por IA",
  aiQuizGenerateDesc: "La IA genera 5 preguntas de gramática estilo TOEFL en tiempo real.",
  aiQuizGenerate: "Generar preguntas con IA",
  aiQuizGenerating: "🤖 La IA está generando preguntas...",
  aiQuizGeneratingTime: "Tarda unos 5-10 segundos",
  aiQuizNew: "Nuevas preguntas",
  aiQuizStats: "Estadísticas acumuladas:",
  aiQuizTimes: "veces",
  aiQuizCheckAnswers: "Revisar respuestas",
  aiQuizPerfect: "🎉 ¡Perfecto!",
  aiQuizCorrectCount: "Correctas",
  aiQuizSaving: "Guardando resultados...",
  aiQuizTryNew: "Probar nuevas preguntas",
  aiQuizError: "Error al generar preguntas con IA. Inténtalo de nuevo.",
  tipsDetailStrategy: "Estrategia detallada",
  subLoginRequired: "Se requiere iniciar sesión.",
  grammarHome: "Inicio",
  grammarExamples: "Frases de ejemplo",
  grammarTestKnowledge: "📝 Prueba de habilidades",
  grammarTestKnowledgeDesc: "¡Intenta preguntas reales relacionadas con la gramática que acabas de aprender!",
  grammarCheckAnswers: "Comprobar respuestas",
  grammarPerfect: "🎉 ¡Perfecto!",
  grammarCorrectCount: "Correctas",
  grammarMockCTA: "🔥 ¡Verifica tus habilidades con un examen completo de simulación!",
  grammarMockCTADesc: "Examen completo de simulación RC de 100 preguntas + notas automáticas de respuestas erróneas",
  grammarStartRCMock: "Iniciar examen de simulación RC",
  grammarPractice5: "Práctica de lectura",
  grammarTestInPractice: "¡Compruébalo en la práctica!",
  grammarTestInPracticeDesc: "Ve cómo los puntos gramaticales aparecen en exámenes TOEFL reales.",
  grammarRelated: "📚 Gramática relacionada",
  wrongAnswersGrammarAI: "IA de gramática",
  streakDays: "días",
  streakLabel: "Racha de estudio",
  streak7: "¡Racha de 7 días!",
  streak14: "¡Racha de 2 semanas!",
  streak30: "¡Increíble! ¡Racha de 30 días!",
  reviewItems: "elementos",
  reviewTodayLabel: "Preguntas de repaso de hoy",
  reviewGoLabel: "📚 Iniciar repaso →",
  loadingQuestions: "Cargando preguntas...",
  tipsCoreTips: "Consejos clave",
  tipsStrategy: "Estrategia",
  tipsCTA: "¡Aplica estas estrategias en la práctica!",
  testScrollHint: "Desplázate para ver la pregunta y las opciones",
  testPart1Label: "Lectura académica",
  testPart2Title: "Conversaciones",
  testPart2Desc: "Escucha el audio y elige la respuesta correcta",
  testPart3Label: "Conferencias",
  creditBuyBtn: "Comprar créditos",
  creditBuyTitle: "Comprar créditos de IA",
  creditBuyDesc: "Compre créditos adicionales para la retroalimentación de IA de Speaking/Writing y la práctica con IA.",
  creditBuyError: "Error al iniciar el pago",
  creditBuyNote: "Pago por PayPal. Los créditos se añaden inmediatamente después de completar el pago.",
  creditUnit: "créditos",
  vocabFlashcardStart: 'Iniciar tarjetas',
  vocabFlashcardStop: 'Detener tarjetas',
  vocabFlashcardEmpty: 'Añade palabras primero para iniciar las tarjetas.',
  vocabFlashcardSpeed: 'Velocidad',
  vocabFlashcardSpeedSlow: 'Lenta',
  vocabFlashcardSpeedNormal: 'Normal',
  vocabFlashcardSpeedFast: 'Rápida',
  vocabFlashcardShuffle: 'Mezclar',
  vocabFlashcardPrev: 'Anterior',
  vocabFlashcardNext: 'Siguiente',
  vocabFlashcardFlip: 'Voltear',
  vocabFlashcardProgress: '{current} / {total}',
};

export default es;
